import { React, useState } from "react";
import "./Emulator.css"
import { useNavigate } from "react-router-dom";

export default function CoordFinder(props) {
    const navigate = useNavigate();

    const [ picture, setPicture ] = useState(null);
    const [ txtCoordX, settxtCoordX ] = useState("");
    const [ txtCoordY, settxtCoordY ] = useState("");

    const changePicture = (e) => {
        if (picture)
            URL.revokeObjectURL(picture);

        setPicture(URL.createObjectURL(e.target.files[0]));
    };

    return (
        <>
            <div>CoordX: {txtCoordX}</div>
            <div>CoordY: {txtCoordY}</div>
            <input type="file" onChange={changePicture} />
            <div className="imgContainer" style={{ height: "594px" }}>
                <img className="phoneDisplay" src={ picture }
                    onClick={(e) => {
                        const bounds = e.currentTarget.getBoundingClientRect();
                        const coordX = e.pageX - bounds.left - window.scrollX;
                        const coordY = e.pageY - bounds.top - window.scrollY;

                        settxtCoordX(coordX);
                        settxtCoordY(coordY);
                }} />
            </div>
        {/* </div> */}
        </>
    );
}
